


import React, { useState, useRef, useEffect } from 'react';
import Routes from '../../../routes';
import { toastResponseError } from '../../../utils';
import PropTypes from 'prop-types';
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';

import CommonModal from '../../Common/CommonModal';


const ReOpenModal = ({ payload, modalOpen, onClose, refreshRequired}) => {
    const fileInput = useRef();
    const [ReOpenReasons, setReOpenReasons] = useState([{ id: 0, name: "Loading..." }]);
    const [ReOpenStatusID,setReOpenStatusID] = useState(null)
    const [Notes, setNotes] = useState('')
    const [ReOpenStatusError,setReOpenStatusError] = useState(null)

    useEffect(() => {
        fetchData()
        if (modalOpen == true) {
            fetchData()
        }
    }, [])

    const fetchData = async () => {
        const response = await fetch(Routes.WorkOrder.SupportData(payload.ID, payload.LocationID,payload.ServicerID));
        const data = await response.json();

        var reasonFilter = data.workOrderStatusReason.filter((obj) => obj.workOrderStatusId == 1)
        var reasons = reasonFilter.map((obj) => { return { value: obj.id, label: obj.name } })
        setReOpenReasons(reasons)

    };


    const validated = () => {
        var isValid = true
        if (!ReOpenStatusID) {
            setReOpenStatusError("This field is required")
            isValid = false
        }

        return isValid
    }

    var SaveReOpen = async () => {

        if (validated() == false) {
            return
        }

        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: payload.ID,
                StatusReasonID: ReOpenStatusID,
                Notes : Notes
            })
        }

        const UpdateResponse = await fetch(Routes.WorkOrder.ReopenWorkOrder(), postConfig)

        console.log(UpdateResponse)
        if (UpdateResponse.status == 200) {
            onClose()
            refreshRequired()
        } else {
            // AB#17142: a forbidden or failed re-open used to fail silently
            await toastResponseError(UpdateResponse, 'Failed to re-open the work order.');
        }

    }

    return (
        <CommonModal open={modalOpen} close={onClose} header={`Re-Open Work Order #${payload.ID}?`}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Select
                        label="Reason"
                        options={ReOpenReasons}
                        onChange={e => setReOpenStatusID(e.target.value)}
                        value={ReOpenStatusID}
                        error={ReOpenStatusError}
                        required
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Input
                        label="Notes"
                        fullWidth
                        value={Notes}
                        onChange={e => setNotes(e.target.value)}
                        variant="outlined"
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={() => SaveReOpen()}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                RE-OPEN WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

ReOpenModal.propTypes = {
    id: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    setDataRefresh: PropTypes.func.isRequired,
};

export default ReOpenModal;
